import type { PositionRow } from "/@lib/utils/positionRow"
import goog from "@tastyworks/boulangerie-bundle"

const OptionType = goog.module.get("com.dough.trade.model.OptionType")

// Mirrors legacy trade-desk-java SecurityComparators.DEFAULT for the
// tie-breaks used by the positions view: non-options before options,
// expiration ascending, strike ascending, PUT before CALL.
export const comparePutBeforeCall = (
  a: PositionRow,
  b: PositionRow
): number => {
  if (a.callOrPut === b.callOrPut) return 0
  if (a.callOrPut == null) return -1
  if (b.callOrPut == null) return 1
  if (a.callOrPut === OptionType.PUT) return -1
  return 1
}

const expirationTime = (row: PositionRow): number | null => {
  const exp = row.expirationDate
  if (exp == null) return null
  const time = new Date(exp).getTime()
  return isNaN(time) ? null : time
}

export const compareExpirationAsc = (
  a: PositionRow,
  b: PositionRow
): number => {
  const aTime = expirationTime(a)
  const bTime = expirationTime(b)
  if (aTime === bTime) return 0
  if (aTime == null) return -1
  if (bTime == null) return 1
  return aTime - bTime
}

export const compareWithinSymbol = (a: PositionRow, b: PositionRow): number => {
  const aNaN = isNaN(a.strikePrice)
  const bNaN = isNaN(b.strikePrice)
  if (aNaN && bNaN) return 0
  if (aNaN) return -1
  if (bNaN) return 1
  const expCompare = compareExpirationAsc(a, b)
  if (expCompare !== 0) return expCompare
  if (a.strikePrice !== b.strikePrice) return a.strikePrice - b.strikePrice
  return comparePutBeforeCall(a, b)
}

export const comparePositions = (a: PositionRow, b: PositionRow): number => {
  const symbolCompare = a.underlyingSymbol.localeCompare(b.underlyingSymbol)
  if (symbolCompare !== 0) return symbolCompare
  return compareWithinSymbol(a, b)
}
